import React from 'react';
import useDevices from './useDevices';

export default function useDevice(deviceId: string | undefined) {
  const { devicesById } = useDevices();
  return React.useMemo(() => devicesById[deviceId ?? ''], [devicesById, deviceId]);
}
